import { createRouter, createWebHashHistory } from 'vue-router';
import Home from '../views/Home.vue';
import Query from '../views/Query.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/Query',
    name: 'Query',
    component: Query,
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
